module.exports = __webpack_public_path__ + "img/photozone-1.93ac3ea1.jpg";